"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteResponseExtractor = exports.crewExtractor = exports.defaultExtractor = exports.Routes = void 0;
var BringgException_1 = require("../../Core/BringgException");
var Route_1 = require("../../Services/Route");
var SessionBasedService_1 = require("../../Services/SessionBasedService");
exports.Routes = {
    GET_CREW: new Route_1.Route('/crews/{:id}', 0 /* HttpMethod.GET */),
    GET_BY_TEAM: new Route_1.Route('/teams/{:teamId}/crews', 0 /* HttpMethod.GET */),
    CREATE_CREW: new Route_1.Route('/crews/', 1 /* HttpMethod.POST */),
    UPDATE_CREW: new Route_1.Route('/crews/{:id}', 2 /* HttpMethod.PUT */),
    DELETE_CREW: new Route_1.Route('/crews/{:id}', 4 /* HttpMethod.DELETE */)
};
var defaultExtractor = function (response) { return response.crews; };
exports.defaultExtractor = defaultExtractor;
var crewExtractor = function (response) { return response.crew; };
exports.crewExtractor = crewExtractor;
var deleteResponseExtractor = function (response) { return response.success; };
exports.deleteResponseExtractor = deleteResponseExtractor;
var CrewService = /** @class */ (function (_super) {
    __extends(CrewService, _super);
    function CrewService(session, store) {
        var _this = _super.call(this, session.config.getApiEndpoint(), session) || this;
        _this.store = store;
        return _this;
    }
    CrewService.prototype.getAllByTeam = function (teamId) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.handleAuthorizedRequest({
                            route: exports.Routes.GET_BY_TEAM,
                            extractor: exports.defaultExtractor,
                            exceptionProducer: BringgException_1.BringgException.serviceException('Failed to get Crews'),
                            routeParams: { teamId: teamId }
                        })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    CrewService.prototype.get = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.handleAuthorizedRequest({
                            route: exports.Routes.GET_CREW,
                            extractor: exports.crewExtractor,
                            exceptionProducer: BringgException_1.BringgException.serviceException('Failed to get Crew'),
                            routeParams: { id: id }
                        })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    CrewService.prototype.create = function (crew) {
        return __awaiter(this, void 0, void 0, function () {
            var primary_driver_id, driver_ids, planned_route_id, team_id, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        primary_driver_id = crew.primary_driver_id, driver_ids = crew.driver_ids, planned_route_id = crew.planned_route_id, team_id = crew.team_id;
                        return [4 /*yield*/, this.handleAuthorizedRequest({
                                route: exports.Routes.CREATE_CREW,
                                extractor: exports.crewExtractor,
                                exceptionProducer: BringgException_1.BringgException.serviceException('Failed to create Crew'),
                                payload: { primary_driver_id: primary_driver_id, driver_ids: driver_ids, planned_route_id: planned_route_id, team_id: team_id }
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    CrewService.prototype.update = function (id, crew) {
        return __awaiter(this, void 0, void 0, function () {
            var primary_driver_id, driver_ids, planned_route_id, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        primary_driver_id = crew.primary_driver_id, driver_ids = crew.driver_ids, planned_route_id = crew.planned_route_id;
                        return [4 /*yield*/, this.handleAuthorizedRequest({
                                route: exports.Routes.UPDATE_CREW,
                                extractor: exports.crewExtractor,
                                exceptionProducer: BringgException_1.BringgException.serviceException('Failed to update Crew'),
                                payload: { primary_driver_id: primary_driver_id, driver_ids: driver_ids, planned_route_id: planned_route_id },
                                routeParams: { id: id }
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    CrewService.prototype.delete = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.handleAuthorizedRequest({
                            route: exports.Routes.DELETE_CREW,
                            extractor: exports.deleteResponseExtractor,
                            exceptionProducer: BringgException_1.BringgException.serviceException('Failed to delete Crew'),
                            routeParams: { id: id }
                        })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    return CrewService;
}(SessionBasedService_1.SessionBasedService));
exports.default = CrewService;
//# sourceMappingURL=CrewService.js.map